const tocLinks = document.querySelectorAll('.ez-toc-link');
const tocSections = document.querySelectorAll('.ez-toc-section');

window.addEventListener('scroll', function() {
    let sectionId = null;
    tocSections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.top >= 0 && rect.top <= window.innerHeight / 2) {
            sectionId = section.getAttribute('ez-toc-data-id');
        }
    });

    if (sectionId) {
        $('.ez-toc-link').removeClass('active');
        $('.ez-toc-title').removeClass('active');
        const activeLink = document.querySelector(`.ez-toc-link[href="${sectionId}"]`);
        dl.log(activeLink);
        if (activeLink) {
            activeLink.classList.add('active');
        }
    
    }
});

//
$(document).ready(function($){
    // Target all input fields inside the list
    $('.gfield_list input').each(function(){
        var colIndex = $(this).closest('td').index(); // get column index

        if(colIndex === 0){
            $(this).attr('placeholder', 'Full Name');
        } else if(colIndex === 1){
            $(this).attr('placeholder', 'Date');
        }
    });

    // Update placeholders when adding a new row
    $(document).on('click', '.gform_list_add_row', function(){
        $('.ginput_list_1 input').each(function(){
            var colIndex = $(this).closest('td').index();

            if(colIndex === 0) $(this).attr('placeholder', 'Employer Name');
            else if(colIndex === 1) $(this).attr('placeholder', 'Job Title');
        });
    });
});

document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".js-sticky");
  if (!targets.length) return;

  let lastScroll = 0;

  window.addEventListener("scroll", () => {
    const currentScroll = window.scrollY;

    targets.forEach(target => {
      if (currentScroll <= 0) {
        target.classList.remove("sticky");
        return;
      }

      if (currentScroll > lastScroll) {
        // скрол вниз
        target.classList.add("sticky");
      } else {
        // скрол вверх
        target.classList.remove("sticky");
      }
    });

    lastScroll = currentScroll <= 0 ? 0 : currentScroll;
  });
});